import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ForgetPasswordComponent } from './AuthModule/forget-password/forget-password.component';
import { LoginComponent } from './AuthModule/login/login.component';
import { PageNotFoundComponent } from './AuthModule/page-not-found/page-not-found.component';
import { RegisterComponent } from './AuthModule/register/register.component';
import { ResetPasswordComponent } from './AuthModule/reset-password/reset-password.component';
import { AuthGuard } from './Shared/auth.guard';
import { GuestGuard } from './guards/guest.guard';

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "login", component: LoginComponent ,canActivate: [GuestGuard] },
  { path: "signup", component: RegisterComponent,canActivate: [GuestGuard] },
  { path: "forget-password", component: ForgetPasswordComponent  ,canActivate: [GuestGuard]},
  { path: "reset-password", component: ResetPasswordComponent ,canActivate: [GuestGuard] },
  { path: '404', component: PageNotFoundComponent },
  // {path: '**', redirectTo: '/404'},
  {
    path: "dashboard", loadChildren: () => import('./DashboardModule/dashboard-module-routing/dashboard-module-routing.module').then(m => m.DashboardModuleRoutingModule), canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
